import { gql } from '@common/hooks/graphql';
import { CommentInfoFragment } from '@common/graphql/fragments';

export const OFFER_INFO_DETAILS_FRAGMENT = gql`
  fragment OfferDetailsInfo on Offer {
    id
    state
    startDate
    endDate
    billingRegularRate
    timeoffDescription
    shiftType
    shiftsPerWeek
    hoursPerShift
    overtimeThreshold
    comments {
      ...CommentInfoFragment
    }
    offerChangeRequests {
      id
      note
      createdAt
      updatedAt
      canCreateResponse {
        value
      }
      worksMembership {
        id
        name
      }
      offerChangeResponse {
        id
        note
        updatedAt
        detail {
          ... on OfferAcceptanceResponseDetail {
            oldStartDate
            oldEndDate
            oldShiftType
            oldShiftsPerWeek
            oldHoursPerShift
            oldTimeoffDescription
          }
          ... on ExtensionOfferAcceptanceResponseDetail {
            oldStartDate
            oldEndDate
            oldShiftType
            oldShiftsPerWeek
            oldHoursPerShift
            oldTimeoffDescription
          }
        }
        worksMembership {
          id
          name
        }
      }
    }
  }
  ${CommentInfoFragment}
`;
